import {
  type AllocationListConfig,
  ViewType,
} from '@/types/schema/page-configs/allocation-list'

export const defaultAllocationListConfig: AllocationListConfig = {
  viewType: ViewType.Standard,
}
